export const column: { id: number; label: string }[] = [
  { id: 0, label: "ID" },
  { id: 1, label: "Наименование" },
  { id: 2, label: "Количество баллов до достижения" },
  { id: 3, label: "Описание" },
  { id: 4, label: "Иконка" },
  { id: 5, label: "Действия" },
];
